<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{$t('page.generic.code')}}</dt>
              <dd class="col-sm-9">{{modelData.code}}</dd>
              <dt class="col-sm-3">{{$t('page.generic.name')}}</dt>
              <dd class="col-sm-9">{{modelData.label}}</dd>
              <dt class="col-sm-3">{{$t('page.generic.version')}}</dt>
              <dd class="col-sm-9">{{modelData.modelVersion}}</dd>
              <dt class="col-sm-3">{{$tc('page.generic.category', 2)}}</dt>
              <dd class="col-sm-9">
                <b-badge v-for="category in modelData.categories" :key="category.id" :variant="`warning`" class="mx-1">
                  <router-link class="cat" :to="{path: `/category/show/${category.id}`}">
                    {{category.code}}
                  </router-link>
                </b-badge>
              </dd>
              <dt class="col-sm-3">{{$tc('page.generic.processType', 1)}}</dt>
              <dd class="col-sm-9">{{processType}}</dd>
              <dt class="col-sm-3">{{$tc('page.generic.format', 1)}}</dt>
              <dd class="col-sm-9">{{modelData.modelFormat}}</dd>
              <dt class="col-sm-3">{{$t('page.generic.description')}}</dt>
              <dd class="col-sm-9">{{ modelData.description }}</dd>
              <dt class="col-sm-3">{{$tc('page.generic.state', 1)}}</dt>
              <dd class="col-sm-9">
                <b-badge :variant="getBadge(modelData.enabled)">{{activeDesc(modelData.enabled)}}</b-badge>
              </dd>
              <dt class="col-sm-3">{{$t('page.generic.cda2')}}</dt>
              <dd class="col-sm-9">
                <b-badge :variant="getBadge(modelData.injectCda2Enabled)">{{activeDesc(modelData.injectCda2Enabled)}}
                </b-badge>
              </dd>
              <dt class="col-sm-3">{{$t('page.generic.qrCodeEnabled')}}</dt>
              <dd class="col-sm-9">
                <b-badge :variant="getBadge(modelData.qrcodeEnabled)">{{activeDesc(modelData.qrcodeEnabled)}}
                </b-badge>
              </dd>
              <dt class="col-sm-3">{{$t('page.generic.jrxmlLinked')}}</dt>
              <dd class="col-sm-9">
                <ul class="list-unstyled">
                  <li v-for="jasperUri in modelData.jasperUris" :key="jasperUri.id">{{jasperUri}}</li>
                </ul>
              </dd>
              <dt class="col-sm-3">{{$t('page.generic.cda2Linked')}}</dt>
              <dd class="col-sm-9">{{modelData.cda2Uri}}</dd>
              <dt class="col-sm-3">{{$tc('page.generic.signer', 2)}}</dt>
              <dd class="col-sm-9">
                <ul class="list-unstyled" v-if="modelData.signaturesInfo">
                  <li v-for="signature in JSON.parse(modelData.signaturesInfo)">
                    {{$t('model.signerItemLabel', {order: (signature.order+1),
                    role: (signature.signerRole == 'patient' ? 'Paziente (o chi ne fa le veci)' :
                    (signature.signerRole == 'operator' ? 'Operatore' : signature.signerRole))})}}
                  </li>
                </ul>
              </dd>
              <dt class="col-sm-3" v-if="modelData.jsonSchema">{{$t('page.generic.jsonSchema')}}</dt>
              <dd class="col-sm-9"  v-if="modelData.jsonSchema">
                <codemirror v-model="modelData.jsonSchema" :options="cmOptions"></codemirror>
              </dd>
              <dt class="col-sm-3">{{$tc('page.generic.utilizer', 2)}}</dt>
              <dd class="col-sm-9">
                <b-badge v-for="company in modelData.companies" :key="company.id"
                         :variant="getBadge(!company.mandatory)">
                  <router-link class="cat" :to="{path: `/company/show/${company.id}`}">
                    {{company.code}}
                  </router-link>
                </b-badge>
              </dd>
              <dt class="col-sm-3">{{$tc('title.documentType', 1)}}</dt>
              <dd class="col-sm-9">
                <b-badge v-for="documentType in modelData.documentTypes" :key="documentType.id"
                         variant="warning">
                  <router-link class="cat" :to="{name: 'doctypeShowRoute', params: {id:documentType.id}}">
                    {{documentType.code}}
                  </router-link>
                </b-badge>
              </dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <router-link class="btn btn-primary float-right" role="button"
                           :to="{path: `/models/edit/${modelData.id}`}" push>
                {{ $t('actions.edit') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import ModelService from '@/services/ModelService'
  // require component
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/javascript/javascript.js'

  const modelService = ModelService.build()

  export default {
    name: 'modelShow',
    components: {
      PageTitle,
      codemirror
    },
    props: {
      id: {
        required: true
      },
      caption: {
        type: String,
        default: "Dati del modello"
      },
      caption2: {
        type: String,
        default: "Modello Jasper"
      }
    },
    data() {
      return {
        modelData: '',
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/javascript',
          lineWrapping: true,
          theme: 'default',
          readOnly: 'nocursor'
        }
      }
    },
    computed: {
      processType() {
        if (this.modelData.processType.length === 0) {
          return ''
        } else {
          return this.modelData.processType.map(_ => _.label).join(', ')
        }
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
      // fetch the data when the view is created and the data is
      // already being observed
      this.fetchData()
    },
    methods: {
      getBadge(active) {
        return active ? 'success' : 'danger'
      },
      activeDesc: function (value) {
        return value ? 'Abilitato' : 'Disabilitato'
      },
      async fetchData() {
        this.modelData = await modelService.read(this.id)
      }
    }
  }
</script>

<style scoped>
  .cat {
    text-underline: none !important;
    color: #000 !important;
  }

  .cat:hover {
    text-underline: none !important;
    color: #000 !important;
  }
</style>
